import React, { useState } from 'react';
import Select, { Option } from '@ingka/select';
import PropTypes from 'prop-types';

import '@ingka/svg-icon/style.scss';
import '@ingka/button/style.scss';

import Button from '@ingka/button';

const PhoneNumbersSelector = ({
    phoneNumbers,
    storeOpened,
    colorButton,
    ariaLabel,
    buttonStyles,
    activateAnalytics,
    PHRASE_TRANSLATIONS,
}) => {
    const [phonesState, setPhonesState] = useState(PHRASE_TRANSLATIONS.phoneNumberSelector);

    const handleClick = () => {
        window.location.href =
            phonesState !== PHRASE_TRANSLATIONS.phoneNumberSelector ? `tel:${phonesState}` : null;
        activateAnalytics();
    };
    return (
        <>
            <div className="form-field">
                <Select
                    hintText={PHRASE_TRANSLATIONS.phoneNumberSelector}
                    onChange={(e) => setPhonesState(e.target.value)}
                    label=""
                    disabled={!storeOpened}
                >
                    {phoneNumbers.map((number, i) => (
                        <Option key={i} value={number.phoneNumber} name={number.identifier} />
                    ))}
                </Select>
            </div>
            {phonesState !== PHRASE_TRANSLATIONS.phoneNumberSelector && (
                <Button
                    data-cy="contactcard-button"
                    type={colorButton}
                    aria-label={ariaLabel}
                    className={buttonStyles}
                    onClick={handleClick}
                >
                    {phonesState}
                </Button>
            )}
        </>
    );
};

PhoneNumbersSelector.propTypes = {
    phoneNumbers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            phoneNumber: PropTypes.string,
            identifier: PropTypes.string,
            createdAt: PropTypes.string,
            entityName: PropTypes.string,
            updatedAt: PropTypes.string,
        }),
    ),
    colorButton: PropTypes.string,
    ariaLabel: PropTypes.string,
    activateAnalytics: PropTypes.func,
    buttonStyles: PropTypes.string,
    PHRASE_TRANSLATIONS: PropTypes.object,
    storeOpened: PropTypes.bool,
};

export default PhoneNumbersSelector;
